import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Button from '../../../ui-core/Button/Button';
// import TimeCounter from '../../../ui-core/TimeCounter';
import { TEXT_CONSTANT } from '../../../constants/app';
import { formatCurrency } from '../../../utils/helpers';

import './style.css';

const JenHealthChallenge = props => {
  const { loading, courseDetail } = props;

  const currentPrice = useMemo(() => {
    return courseDetail?.attributes?.amount
      ? +courseDetail?.attributes?.amount / 100
      : 0;
  }, [courseDetail?.attributes?.amount]);

  const originalPrice = useMemo(() => {
    return currentPrice + (courseDetail?.attributes?.discount || 0);
  }, [currentPrice, courseDetail?.attributes?.discount]);

  const handleClick = () => {
    if (props.onClick) {
      props.onClick(
        TEXT_CONSTANT.REGISTER,
        'isSignup',
        TEXT_CONSTANT.GRATEFUL_FOR_MY_BODY,
      );
    }
  };
  return (
    <div className="jen-health-challenge-section">
      <h1 className="mb-4 pb-2">{TEXT_CONSTANT.JOIN_30_DAYS}</h1>
      {Boolean(courseDetail?.attributes?.amount) && (
        <div className="d-flex align-items-center">
          {Boolean(courseDetail?.attributes?.discount) && (
            <p className="jen-health-price-cut">
              {formatCurrency(
                originalPrice,
                courseDetail?.attributes?.currency,
                2,
              )}
            </p>
          )}
          <p className="jen-health-price">
            {formatCurrency(
              currentPrice,
              courseDetail?.attributes?.currency,
              2,
            )}
          </p>
          {props?.courseDetail?.attributes?.discount > 0 ? (
            <p className="jen-health-para">For a limited time</p>
          ) : (
            ''
          )}
        </div>
      )}
      {!(new Date() > new Date(props.endDate)) && (
        <p className="bare-foot-price">
          {TEXT_CONSTANT.GET_IN_BEFORE_PRICE_INCREASE}
        </p>
      )}
      {/* <TimeCounter endDate={props.endDate} /> */}
      <Button
        isDisabled={loading}
        isLoading={loading}
        class="sign-up-button-new text-uppercase"
        text={TEXT_CONSTANT.REGISTER}
        onClick={handleClick}
      />
    </div>
  );
};

JenHealthChallenge.propTypes = {
  onClick: PropTypes.func,
  endDate: PropTypes.string,
  courseDetail: PropTypes.object,
  loading: PropTypes.bool,
};

export default JenHealthChallenge;
